import i18n from "../../../i18n"

export const professors = {
    department: i18n.t("ba_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1636/1227-valetras-2.jpg',
                fname: 'vasileios',
                lname: 'aletras',
                title: 'proedrosTmimatos',
                tel: '2310 891.505',
                email: 'valetras@uom.edu.gr',
                building: 'ΗΘ',
                office: '410'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'andreas',
                lname: 'andronikidis',
                title: 'kathigitis',
                tel: '2310 891.584',
                email: 'a.andronikidis@uom.edu.gr',
                building: 'ΗΘ',
                office: '308'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1620/3909-vassiliadisCh_ed-2.jpg',
                fname: 'christos',
                lname: 'vasileiadis',
                title: 'kathigitis',
                tel: '2310 891.581',
                email: 'chris@uom.edu.gr',
                building: 'ΗΘ4',
                office: '412'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1633/2020-Vouzas_ed-2.jpg',
                fname: 'fotios',
                lname: 'vouzas',
                title: 'kathigitis',
                tel: '2310 891.583',
                email: 'vouzas@uom.edu.gr',
                building: 'ΗΘ',
                office: '210'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1624/1596-acg-2.jpg',
                fname: 'andreas',
                lname: 'georgiou',
                title: 'kathigitis',
                tel: '2310 891.569',
                email: 'acg@uom.edu.gr',
                building: 'ΗΘ3',
                office: '305'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1632/1198-kgotza-2.jpg',
                fname: 'aikaterini',
                lname: 'gkotzamani',
                title: 'kathigitria',
                tel: '2310 891.568',
                email: 'kgotza@uom.edu.gr',
                building: 'ΗΘ2',
                office: '207'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1630/1582-eleytheriadis-2.jpg',
                fname: 'iordanis',
                lname: 'eleftheriadis',
                title: 'kathigitis',
                tel: '2310 891.591',
                email: 'jordan@uom.edu.gr',
                building: 'ΗΘ4',
                office: '402'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1625/3994-DimitrisMihail-2.jpg',
                fname: 'dimitrios',
                lname: 'michail',
                title: 'kathigitis',
                tel: '2310 891.594',
                email: 'mihail@uom.edu.gr',
                building: 'ΗΘ4',
                office: '406'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1638/3587-moschidis-2.png',
                fname: 'odysseas',
                lname: 'moschidis',
                title: 'kathigitis',
                tel: '2310 891.592',
                email: 'fmos@uom.edu.gr',
                building: 'ΗΘ',
                office: '407'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1627/4641-Soumpeniotis_ed-2.jpg',
                fname: 'dimitrios',
                lname: 'soumpeniotis',
                title: 'kathigitis',
                tel: '2310 891.580',
                email: 'subedim@uom.edu.gr',
                building: 'ΗΘ2',
                office: '206'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1622/6051-Tarabanis_ed-2.jpg',
                fname: 'konstantinos',
                lname: 'tarampanis',
                title: 'kathigitis',
                tel: '2310 891.578',
                email: 'kat@uom.edu.gr',
                building: 'ΗΘ3',
                office: '307'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1621/1223-tsiotras-2.jpg',
                fname: 'georgios',
                lname: 'tsiotras',
                title: 'kathigitis',
                tel: '2310 891.575',
                email: 'tsiotras@uom.edu.gr',
                building: 'ΗΘ2',
                office: '212'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1641/2002-TsiotsiouREd-2.jpg',
                fname: 'rodoula',
                lname: 'tsiotsou',
                title: 'kathigitria',
                tel: '2310 891.576',
                email: 'rtsiotsou@uom.edu.gr',
                building: 'ΗΘ2',
                office: '201'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1650/1682-hajidim-2.jpg',
                fname: 'ioannis',
                lname: 'chatzidimitriou',
                title: 'kathigitis',
                tel: '2310 891.585',
                email: 'hajidim@uom.edu.gr',
                building: 'ΗΘ3',
                office: '312'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'konstantinos',
                lname: 'agorastos',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.572',
                email: 'agoras@uom.edu.gr',
                building: 'ΗΘ2',
                office: '208'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1640/4007-KatouA-2.jpg',
                fname: 'anastasia',
                lname: 'katou',
                title: 'Αναπληρώτρια Καθηγήτρια',
                tel: '2310 891.587',
                email: 'akatou@uom.edu.gr',
                building: 'ΗΘ',
                office: '405'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1639/3908-PapathanasiouJason_ed-2.jpg',
                fname: 'iason',
                lname: 'papathanasiou',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.571',
                email: 'jasonp@uom.edu.gr',
                building: 'Κτήριο της ΟΔΕ',
                office: '203'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1643/1565-tsironis-2.jpg',
                fname: 'loukas',
                lname: 'tsironis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.597',
                email: 'loukas@uom.edu.gr',
                building: 'ΗΘ',
                office: '403'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1646/1226-v-grougiou-2.jpg',
                fname: 'vasiliki',
                lname: 'grougiou',
                title: 'epikouriKathigitria',
                tel: '2310 891.557',
                email: 'vgrougiou@uom.edu.gr',
                building: 'ΗΘ',
                office: '302'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1645/1179-drogalas-2.jpg',
                fname: 'georgios',
                lname: 'drogalas',
                title: 'epikourosKathigitis',
                tel: '2310 891.537',
                email: 'drogalas@uom.edu.gr',
                building: 'ΗΘ',
                office: '306'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/11228/13759-ekal1-2.jpg',
                fname: 'euaggelos',
                lname: 'kalampokis',
                title: 'epikourosKathigitis',
                tel: '2310 891.588',
                email: 'ekal@uom.edu.gr',
                building: 'ΗΘ3',
                office: '315'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1648/3910-KaparisK-2.jpg',
                fname: 'konstantinos',
                lname: 'kaparis',
                title: 'epikourosKathigitis',
                tel: '2310 891.573',
                email: 'k.kaparis@uom.edu.gr',
                building: 'ΗΘ',
                office: '205'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/7951/6625-kafetzopoulos-id-2.jpg',
                fname: 'dimitrios',
                lname: 'kafetzopoulos',
                title: 'epikourosKathigitis',
                tel: '2310 891.567',
                email: 'dimkafe@uom.edu.gr',
                building: 'ΗΘ',
                office: '202'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1644/3524-IoannisKonstantaras-2.jpg',
                fname: 'ioannis',
                lname: 'konstantaras',
                title: 'epikourosKathigitis',
                tel: '2310 891.695',
                email: 'ikonst@uom.edu.gr',
                building: 'ΗΘ',
                office: '201'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1642/1221-tampakoudis-2.jpg',
                fname: 'ioannis',
                lname: 'tampakoudis',
                title: 'epikourosKathigitis',
                tel: '2310 891.595',
                email: 'tampakoudis@uom.edu.gr',
                building: 'Πύργος ΟΔΕ',
                office: '301(Α)'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1647/2773-LeonidasHatzithomas-2.jpg',
                fname: 'leonidas',
                lname: 'chatzithomas',
                title: 'epikourosKathigitis',
                tel: '2310 891.684',
                email: 'hatzithomas@uom.edu.gr',
                building: 'ΗΘ',
                office: '301'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1635/13677-kourdoumpalou070722-2.jpg',
                fname: 'stavroula',
                lname: 'kourdoumpalou',
                title: 'Λέκτορας',
                tel: '2310 891.599',
                email: 'kroula@uom.edu.gr',
                building: 'ΗΘ',
                office: '310'
            }
        ]
}